import { Card, CbhIcon } from "@clipboard-health/ui-components";
import { Skeleton, Stack } from "@mui/material";

export function ShiftBlockCardSkeleton() {
  return (
    <Card>
      <Stack spacing={1} sx={{ padding: 2 }}>
        <Stack direction="row" spacing={2}>
          <Skeleton width={150} />
          <Skeleton width={50} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <CbhIcon type="clock" size="small" color={(theme) => theme.palette.action.disabled} />
          <Skeleton width={150} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <CbhIcon
            type="calendar-clock"
            size="small"
            color={(theme) => theme.palette.action.disabled}
          />
          <Skeleton width={50} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <CbhIcon type="dollar" size="small" color={(theme) => theme.palette.action.disabled} />
          <Skeleton width={200} />
          <Skeleton width={50} />
        </Stack>
        <Card
          aria-label="Facility details skeleton"
          sx={{ border: 1, borderColor: "divider", boxShadow: "none" }}
        >
          <Stack sx={{ padding: 2 }}>
            <Skeleton width={150} />
            <Skeleton width={50} />
          </Stack>
        </Card>
      </Stack>
    </Card>
  );
}
